import { IUpdateControleResiduoUseCase } from "../../../presentation/useCases/update/update_controle_residuo_use_case";
import { UpdateControleResiduoRequestModel, UpdateControleResiduoResponseModel } from "../../models/obras_sustentabilidade_model";
import { IObrasRepository } from "../../repositories/obras_repository";

/**
 * UpdateControleResiduoUseCase
 */

export class UpdateControleResiduoUseCase implements IUpdateControleResiduoUseCase {
  constructor(private readonly repository: IObrasRepository) {}

  async updateControleResiduo(model: UpdateControleResiduoRequestModel): Promise<UpdateControleResiduoResponseModel> {
    return await this.repository.updateControleResiduo(model);
  }
}
